export class GameConstants {

    // version: v0.month.day.hour
    public static readonly VERSION = "v0.11.13.14";

    public static readonly RELOAD_BASE_TICKS = 10;
    public static readonly ARROW_SPEED = .575; // in cells / tick
    public static readonly MORTAR_SPEED = .2;

    // los nombres de los enemigos
    public static readonly ENEMY_WOOD = "wood";
    public static readonly ENEMY_ROCK = "rock";
    public static readonly ENEMY_WATER = "water";
    public static readonly ENEMY_ICE = "ice";
    public static readonly ENEMY_WIND = "wind";
    public static readonly ENEMY_FIRE = "fire";
    public static readonly ENEMY_ELECTRIC = "electric";

    // los nombres de las torretas
    public static readonly TURRET_PEA = "pea";
    public static readonly TURRET_MORTAR = "mortar";
    public static readonly TURRET_SPLAT = "splat";
    public static readonly TURRET_BZZT = "bzzt";
    public static readonly TURRET_ROCKETS = "rockets";
    public static readonly TURRET_MINES = "mines";
    public static readonly TURRET_FIRE = "fire";
    public static readonly TURRET_TELEPORT = "teleport";

    // attributes
    public static readonly ATTRIBUTE_DAMAGE = "damage";
    public static readonly ATTRIBUTE_RELOAD = "reload";
    public static readonly ATTRIBUTE_RANGE = "range";
    public static readonly ATTRIBUTE_EXPLOSION_RANGE = "explosionRange";
    public static readonly ATTRIBUTE_INTENSITY = "intensity";
    public static readonly ATTRIBUTE_DURATION = "duration";
    public static readonly ATTRIBUTE_PRICE_UPGRADE = "priceUpgrade";
    public static readonly ATTRIBUTE_TELEPORT_DISTANCE = "teleportDistance";
    public static readonly ATTRIBUTE_MAX_NUM_MINES = "maxNumMines";

    // estrategia de disparo
    public static readonly STRATEGY_SHOOT_FIRST = "first";
    public static readonly STRATEGY_SHOOT_LAST = "last";
    public static readonly STRATEGY_SHOOT_CLOSEST = "closest";
    public static readonly STRATEGY_SHOOT_WEAKEST = "weakest";
    public static readonly STRATEGY_SHOOT_STRONGEST = "strongest";

    public static readonly STRATEGIES_ARRAY = [  
                                                GameConstants.STRATEGY_SHOOT_FIRST, 
                                                GameConstants.STRATEGY_SHOOT_LAST, 
                                                GameConstants.STRATEGY_SHOOT_CLOSEST, 
                                                GameConstants.STRATEGY_SHOOT_WEAKEST, 
                                                GameConstants.STRATEGY_SHOOT_STRONGEST
                                            ];

    // caracteristicas de los enemigos
    public static readonly HEALER_HEALING_TICKS = 100;
    public static readonly HEALER_STOP_TICKS = 10;
    public static readonly HEALER_HEALING_RADIUS = 2;

    public static readonly WIND_IMPROVING_TICKS = 100;
    public static readonly WIND_STOP_TICKS = 1;
    public static readonly WIND_IMPROVING_RADIUS = 2;

    public static readonly DIFFICULTY_MODIFIER = 8e-4;
    public static readonly DIFFICULTY_EXPONENT = 1.9;
    public static readonly DIFFICULTY_LINEAR = 20;
    public static readonly MIN_HEALTH_MODIFIER = 0.5;
    public static readonly REWARD_MODIFIER = 0.4;
    public static readonly REWARD_EXPONENT = 0.5;
    public static readonly MIN_REWARD_MODIFIER = 1;
    public static readonly EARLY_BONUS_MODIFIER = 3;
    public static readonly EARLY_BONUS_EXPONENT = 0.6;
}
